import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import TextInput from '../inputs/text-input'
import FlashAlert from '../../flash-alert'

function ConfirmationForm(props) {
  const { alert, person, isLoading } = props
  const { register, handleSubmit, setValue, formState: { errors }  } = useForm({})
  const [counter, setCounter] = useState(0)

  useEffect(() => {
    var timerId = null
    timerId = counter > 0 && setTimeout(() => setCounter(counter - 1), 1000)
    return () => {
      timerId && clearTimeout(timerId)
    }
  }, [counter])

  useEffect(() => {
    props.confirm && props.confirm(() => handleSubmit(onSubmit))
  }, [])

  const onSubmit = (data) => {
    props.confirmCode({...data, person: person})
  }

  const onResend = () => {
    props.resendCode({person: person})
    setCounter(60)
  }

  const warning = () => {
    if (counter == 0) {
      return <div className='person__warning'>Didn't receive a pin? Click&nbsp;
        <span className='person__warning__link' onClick={onResend}>here</span> to resend
      </div>
    }
    else {
      return <div className='person__warning'>{`Send again in ${counter} seconds`}
      </div>
    }
  }

  return <form className={isLoading ? 'isLoading' : ''} onSubmit={handleSubmit(onSubmit)}>
    <div className='row'>
      { isLoading && <div className='animated-spinner'></div> }
      { alert &&
        <div className='col-xs-12'>
          <FlashAlert text={alert.text} type={alert.type} onHide={() => props.setAlert(null)} />
        </div>
      }
      <div className='col-xs-12 col-md-5'>
        <TextInput
          {...register('code', {
            required: 'Is required',
            pattern: {
              value: /^[0-9]{4}$/i,
              message: 'Invalid code format'
            } 
          })}
          label='Enter Verification Code'
          mandatory='true'
          error={errors.code}
          onChange={(e) => setValue('code', e.target.value)}
        />
      </div>
      <div className='col-xs-12'>
        {warning()}
        <div className='navigation-buttons desktop-only'>
          <button className='btn btn-next' type='submit'>Verify & Go to Payment</button>
          <button className='btn btn-back' onClick={(e) => {e.preventDefault(); props.onPrevStep()}}>Back</button>
        </div>
      </div>
    </div>
  </form>
}

ConfirmationForm.propTypes = {
  alert: PropTypes.object,
  person: PropTypes.object,
  confirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  confirmCode: PropTypes.func.isRequired,
  resendCode: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
}

export default ConfirmationForm
